/* gl_textarea.module.js */

"use strict";
const angular = require("angular");

module.exports = angular.module("gl_textarea", []);


/* Generated Dependencies */
module.exports.directive("glTextarea", require('././directives/gl_textarea.directive.js'));